import Tooltip from 'bootstrap/js/dist/tooltip';
import {includes} from 'lodash';

const loaded = [];

const initTooltips = () => {
    const elements = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    elements.map((element) => {
        // Prevent multiple executions
        if (includes(loaded, element)) {
            return;
        }
        loaded.push(element);
        const tooltip = new Tooltip(element);
        element.addEventListener('click', () => {
            tooltip.hide();
        });
    });
};

export default class BootstrapTooltips {

    static init() {
        initTooltips();
        document.addEventListener('livewire:load', () => {
            window.livewire.hook('message.processed', () => {
                initTooltips();
            });
        });
    }

}
